import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // A tab keeps working after its user signs in again elsewhere: reuse the renewed
  // session only for the same uid, so a tab never acts as another user.
  wootApi.interceptors.request.use(config => {
    const pinnedUid = wootApi.defaults.headers.common.uid;
    if (!pinnedUid || !Auth.hasAuthCookie()) return config;
    const current = Auth.getAuthData();
    if (current.uid !== pinnedUid) return config;
    ['access-token', 'token-type', 'client', 'expiry'].forEach(key => {
      config.headers[key] = current[key];
    });
    return config;
  });
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
